const ACTIVE_ORG_STORAGE_KEY = 'activeOrgGuid';

export function getActiveOrgGuid(): string | null {
  return window.localStorage.getItem(ACTIVE_ORG_STORAGE_KEY);
}

export function setActiveOrgGuid(orgGuid: string | null): void {
  if (orgGuid) {
    window.localStorage.setItem(ACTIVE_ORG_STORAGE_KEY, orgGuid);
  } else {
    window.localStorage.removeItem(ACTIVE_ORG_STORAGE_KEY);
  }
}
